import React from 'react'
 
import { useMemo,useState,useEffect } from "react";
import { MAPS_API_KEY } from "../../Constants";
import { GoogleMap, InfoWindow, Marker,useLoadScript,MarkerClusterer } from "@react-google-maps/api";
import { FaMapMarker, FaPhone, FaUser } from 'react-icons/fa';

const SurveyMapViewer = (props) => {

    const { responseLocations,surveyName } = (props.location && props.location.state) || {};
    const center = useMemo(() => ({ lat: 18.52043, lng: 73.856743 }), []);
    const [markers, setmarkers] = useState([]);
   

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MAPS_API_KEY  
      });
    
    const formatData=()=>{
      let records=[];
       
      responseLocations.forEach((resp)=>{
          let pos={};
          try{
pos= resp.location;
         
         
        

      
      }catch(e){}
      let lat=pos?.latitude??0;
      if(!lat==0){
          records.push({
              id:resp.id,
              
              name:resp.name,
               
              endedOn:resp.endedOn,
              position:{lat:pos?.latitude??0,lng:pos?.longitude??0}
          })
      }
     
      })

        setmarkers(records);
    }

    useEffect(() => {
        formatData();
        return () => {
    
        }
      }, [])
    const libraries = ["places"]
    const [selectedElement, setSelectedElement] = useState(null);
    // const [activeMarker, setActiveMarker] = useState(null);
    const [showInfoWindow, setInfoWindowFlag] = useState(true);
   


 
const [activeMarker, setActiveMarker] = useState(null);

const handleActiveMarker = (marker) => {
  if (marker === activeMarker) {
    return;
  }
  setActiveMarker(marker);
};

const handleOnLoad = (map) => {
  const bounds = new window.google.maps.LatLngBounds();
  
  markers.forEach(({ position }) => bounds.extend(position));
  map.fitBounds(bounds);
};
 
     let position =  {lat:4.8101400000000005 , lng: 45.17062166666666};
    const options = {
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
      };
    return (
        <div>
            {/* {JSON.stringify(markers)} */}
            <h1>Surveys → {surveyName} →  Response Geolocation </h1>
       
        {isLoaded ?
        <GoogleMap
          onLoad={handleOnLoad}
          onClick={() => setActiveMarker(null)}
          mapContainerStyle={{ width: "98vw", height: "80vh" }}
          className="g_map"
        >
          
          <MarkerClusterer options={options} minimumClusterSize={2}>
        {(clusterer) => (
          <div>
           
          {markers?.map(({ id, name,endedOn, position }) => 
            <Marker
              key={id}
              position={position}
                clusterer={clusterer}

              onClick={() => handleActiveMarker(id)}
            >
              {activeMarker === id ? (
                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                  <div>
                    <h4>Response Details</h4>
                     <FaUser></FaUser> Data Collector : <b> {name} </b>  <br/>
                     <FaPhone></FaPhone> Date/Time : <b> {endedOn}  </b> <br/>
                  <FaMapMarker></FaMapMarker>   latitude : <b> {position?.lat}</b> &nbsp;&nbsp;&nbsp;
                     longitude : <b> {position?.lng } </b><br/>

                    
                        </div>
                </InfoWindow>
              ) : null}
            </Marker>
          ) }  
          </div>)}
              </MarkerClusterer>

        </GoogleMap> : <h1>Loading..</h1>
}
        </div>

      );
 
 
  
 
}

export default SurveyMapViewer



 